export default __webpack_public_path__ + "static/media/samcart_logo.030ef08c.png";